<template>
  <div class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MailModal",
  inject: [
    '$modal'
  ],
  data() {
    return {
      modal: null,
    }
  },
  mounted() {
    this.modal = new this.$modal(this.$el);
  },
  methods: {
    show() {
      this.modal.show();
    },
    hide() {
      this.modal.hide();
    },
  },
   watch:{
    $route(){
      this.hide();
    }
  }
}
</script>
